<template>
  <section style="display: inherit">
    <a @click="fnShowModal()" v-b-tooltip.hover title="Create / View message">
      <div v-if="quote.has_messages == 1 && quote.messages_for_other == 0">
        <span class="badge bdg-not-proceeding"
          ><i class="las la-envelope-open"></i
        ></span>
      </div>
      <div v-else-if="quote.has_messages == 1 && quote.messages_for_other > 0">
        <span class="badge bdg-new"><i class="las la-envelope"></i></span>
      </div>
      <div v-else>
        <i class="las la-paper-plane text-primary fs-1100"></i>
      </div>
    </a>

    <b-modal
      ref="userModal"
      size="lg"
      hide-footer
      title="Message Us or Get us to Help Close a Deal"
    >
      <div class="d-block p-3">
        <div class="row" v-if="msgContentAll.length == 0">
          <div class="col-lg-12 col-md-12 col-12">
            <h4 class="text-danger">Here to Help!</h4>
            <p class="mt-3">
              We are always here to help and are tied to your success, so
              winning the deal means everything to us.
            </p>
            <p>
              You can message us anytime by clicking on the icon below. From
              simple questions or updates to helping close a deal, we're always
              here to help.
            </p>
            <p>
              <strong
                >If we're assisting in closing a deal, please ensure the client
                knows that a member of VSA will be calling.</strong
              >
            </p>
          </div>
        </div>

        <!-- Compose a new message Start-->
        <div class="row">
          <div class="col-12 text-right">
            <button
              class="btn btn-sm btn-primary"
              @click="isCompose = !isCompose"
              v-b-tooltip.hover
              title="Create a new message"
            >
              <i class="lar la-envelope fs-1000 pl-1"></i>
            </button>
          </div>
        </div>

        <div class="row" v-if="isCompose">
          <div class="col-lg-12 col-md-12 col-12">
            <div class="form-group">
              <label class="" for="subject">Subject</label>
              <input class="form-control" type="text" v-model="subject" />
              <div class="invalid-feedback" v-if="errors.subject">
                {{ errors.subject[0] }}
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-12">
            <div class="form-group">
              <label class="" for="note">Message</label>
              <vue-editor v-model="body" :editor-toolbar="customToolbar" />
              <div class="invalid-feedback" v-if="errors.msgBody">
                {{ errors.msgBody[0] }}
              </div>
            </div>
          </div>

          <div class="col-12 text-right">
            <button
              type="button"
              class="btn btn-dark btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="fnSendMsg()"
              class="btn btn-primary btn-sm"
            >
              <b-spinner small v-if="loading" class="mr-2"></b-spinner>
              Send
            </button>
          </div>
        </div>
        <!-- Compose a new message End-->

        <div v-if="msgContentAll.length > 0" class="mt-3">
          <template>
            <div
              class="accordion"
              role="tablist"
              v-if="msgContentAll.length > 0"
            >
              <div v-for="(msgs, index3) in msgContentAll" :key="index3">
                <template>
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button
                        block
                        href="#"
                        v-b-toggle="'accordion-' + index3"
                        variant="warning"
                        class="text-left"
                        @click="fnReadMsg(msgs)"
                        >{{ msgs.subject }} |
                        {{ msgs.updated_at | dateConvertDDMMYYYYTime }}
                        <span v-if="msgs.read_by_other > 0" class="text-danger"
                          ><i class="las la-bell"></i
                        ></span>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      :id="'accordion-' + index3"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <!-- Reply section Start-->
                        <div class="text-right" v-if="msgs.sender_party == 1">
                          <button
                            type="button"
                            @click="fnOpenResponse(index3)"
                            class="btn btn-primary btn-sm"
                            v-b-tooltip.hover
                            title="Reply"
                          >
                            <i class="las la-reply fs-1000"></i>
                          </button>
                        </div>

                        <div
                          class="row"
                          v-if="openResponse == index3 && openSection"
                        >
                          <div class="col-lg-12 col-md-12 col-12">
                            <div class="form-group">
                              <label class="" for="note">Message</label>
                              <vue-editor
                                v-model="body"
                                :editor-toolbar="customToolbar"
                              />
                              <div
                                class="invalid-feedback"
                                v-if="errors.msgBody"
                              >
                                {{ errors.msgBody[0] }}
                              </div>
                            </div>
                          </div>

                          <div class="col-12 text-right">
                            <button
                              type="button"
                              class="btn btn-dark btn-sm mr-2"
                              @click="hideModal"
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              @click="fnReplyMsg(msgs)"
                              class="btn btn-primary btn-sm"
                            >
                              <b-spinner
                                small
                                v-if="loading"
                                class="mr-2"
                              ></b-spinner>
                              Send
                            </button>
                          </div>
                        </div>
                        <!-- Reply section End-->

                        <!-- List old messages -->
                        <div
                          v-for="(item, index4) in msgs.msg_content"
                          :key="index4"
                        >
                          <hr v-if="index4 > 0" />
                          <p class="mb-0 fw-400">Date:{{ item.created_at }}</p>
                          <p class="mb-0 fw-400">
                            Created By:{{ item.created_by }}
                          </p>
                          <p
                            class="mb-0 fw-700"
                            v-if="item.to_msg == 1 && item.msg_type == 'new'"
                          >
                            Message
                          </p>
                          <p
                            class="mb-0 fw-700"
                            v-if="item.to_msg == 2 && item.msg_type == 'reply'"
                          >
                            Response Message
                          </p>

                          <p
                            class="mb-0 fw-700"
                            v-if="item.to_msg == 2 && item.msg_type == 'new'"
                          >
                            Message
                          </p>
                          <p
                            class="mb-0 fw-700"
                            v-if="item.to_msg == 1 && item.msg_type == 'reply'"
                          >
                            Response Message
                          </p>

                          <b-card-text v-html="item.body"></b-card-text>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
import * as messageService from '../../services/message.service'
import * as msgService from '../../services/msg.service'
import * as authService from '../../services/auth.service'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'ModalMsgDealer',
  props: ['quote', 'quoteId'],
  components: {},
  data() {
    return {
      loginUser: {},
      openResponse: 100,
      openSection: false,
      isCompose: false,
      msgContentAll: [],
      selectedMsg: {},
      errors: {},
      loading: false,

      subject: '',
      body: '',
      msgContent: {},
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }]
      ]
    }
  },
  computed: {
    ...mapGetters(['getQuotePaginateData', 'getQuotePaginate'])
  },
  methods: {
    ...mapActions(['fetchNewMsgs', 'fetchQuotePaginate']),
    fnShowModal() {
      this.fnGetMsgs(this.quoteId)
      this.showModal()
    },
    hideModal() {
      this.$refs.userModal.hide()
    },
    showModal() {
      this.$refs.userModal.show()
    },
    // Get Messages
    fnGetMsgs: async function (quoteId) {
      try {
        const res = await msgService.all(quoteId)
        this.msgContentAll = res.data
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Messages',
          'Something wrong on quote status update'
        )
      }
    },
    // To send messages
    fnSendMsg: async function () {
      this.errors = ''
      let msgObj = {}
      msgObj = [
        {
          body: this.body,
          created_at: moment().format('DD-MM-YYYY hh:mm A'),
          created_by: this.loginUser.firstName,
          msg_type: 'new',
          from_msg: 2,
          to_msg: 1,
          sender_id: this.loginUser.id
        }
      ]

      let obj = {
        quoteId: this.quoteId,
        subject: this.subject,
        msgContent: msgObj,
        sender_party: 2
      }
      try {
        this.loading = true
        const res = await msgService.add(obj)

        if (res.status == 200) {
          this.fetchQuotePaginate(this.getQuotePaginate)
          this.hideModal()
          messageService.fnSweetAlertSuccessToast(
            'New message',
            'Send successfully'
          )

          this.subject = ''
          this.body = ''
          this.sender_party = ''
        }
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'New message',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'New message',
              'Something wrong'
            )
            break
        }
      }

      this.loading = false
    },
    // Reply Message
    fnReplyMsg: async function (msgs) {
      this.errors = ''
      let msgObj = {}
      msgObj = {
        body: this.body,
        created_at: moment().format('DD-MM-YYYY hh:mm A'),
        created_by: this.loginUser.firstName,
        msg_type: 'reply',
        from_msg: 2,
        to_msg: 1,
        sender_id: this.loginUser.id
      }

      let obj = {
        msgContent: msgObj,
        sender_party: 2
      }
      try {
        this.loading = true

        const res = await msgService.update(msgs.id, obj)

        if (res.status == 200) {
          messageService.fnSweetAlertSuccessToast(
            'Reply message',
            'Send successfully'
          )

          this.fnGetMsgs(this.quoteId)

          this.subject = ''
          this.body = ''
          this.sender_party = ''
          this.openSection = !this.openSection
        }
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Reply message',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Reply message',
              'Something wrong'
            )
            break
        }
      }

      this.loading = false
    },

    fnOpenResponse(index) {
      this.openResponse = index

      this.openSection = !this.openSection
    },

    // After collapse open that read_by_other going to 0, it says that they have read it.
    fnReadMsg(msgs) {
      if (msgs.read_by_other == 1) {
        msgService.fnUpdateMsgReadStatus(msgs.id, 'other', 0)
        this.fetchQuotePaginate(this.getQuotePaginate)
        this.fetchNewMsgs({
          dealerUserId: this.loginUser.id,
          reader: 'other'
        })
      } else {
        return
      }
    }
  },
  created() {
    this.loginUser = authService.getUserFromToken()
  }
}
</script>
